import axios from "axios";
import config from "@/config";
import {
    storage,
    Storage
} from "@/storage";

class HttpClient {
    loadPage(page, action, params) {
        let formData = new FormData();
        let request = page+"/"+action;
        if( params!=null){

                for (var key in params) {
                    formData.append(key,params[key]);
                };
        };
        formData.append("request", request);
        return fetch(
            `${config.MONCAHIER_API_URL}`, {
                method: "POST",
                body: formData,
                mode: 'cors',

            }
        );
    }
}
const http = new HttpClient()
export default http